<template>
  <div class="box">
    <div class="query">
      <div class="status">
        <div
          :class="active === 'school_passed' ? 'active' : ''"
          @click="tab('school_passed')"
        >未处理（{{untreatedNum}}）</div>
        <div
          :class="active === 'enterprise_passed' ? 'active' : ''"
          @click="tab('enterprise_passed')"
        >通过（{{passedNum}}）</div>
        <div
          :class="active === 'enterprise_refused' ? 'active' : ''"
          @click="tab('enterprise_refused')"
        >不合适（{{refusedNum}}）</div>
      </div>
      <el-input placeholder="请输入学校名称" prefix-icon="el-icon-search" v-model="searchParams.school_name"></el-input>
    </div>
    <ul class="resume">
      <li v-for="item in studentApplyList" :key="item.apply_id">
        <div class="left-content">
          <img src="../../assets/img/resume/profile-photo.png" alt />
          <div class="base-info">
            <div class="line-1">
              <strong>{{item.student_name}}</strong>
              <span>{{item.job_name}}</span>
            </div>
            <div class="line-2">
              <span>{{item.school_name}}</span>
              <!-- <span>大专</span> -->
              <span>{{item.major}}</span>
              <span>{{item.fdGraduationYear}}届</span>
              <span>{{item.phone}}</span>
            </div>
          </div>
        </div>
        <div class="right-content">
          <span>{{item.created_at}}</span>
          <span class="edit-btn" @click.stop="edit(item.apply_id, item.job_id)">编辑</span>
          <div class="operate" v-if="operate && (operateId === item.apply_id)">
            <div @click="update('school_passed')">待定</div>
            <div @click="update('enterprise_passed')">录用</div>
            <div @click="update('enterprise_refused')">不合适</div>
          </div>
        </div>
      </li>
    </ul>
    <v-pagination
      ref="pagination"
      :total="total"
      @size-change="getStudentApplyList"
      @current-change="getStudentApplyList"
    ></v-pagination>

    <v-payment v-if="!$store.state.paymentStatus"></v-payment>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import formatter from "@/assets/js/mixins/formatter";
import PaymentTipDialog from '@/components/PaymentTipDialog'

var num = {
  untreatedNum: 0,
  passedNum: 0,
  refusedNum: 0
};
let update = {
  operate: false,
  operateId: null,
  jobId: null
};

export default {
  mixins: [formatter],
  components: {
    "v-pagination": pagination,
    'v-payment': PaymentTipDialog,
  },
  data() {
    return {
      active: "school_passed", // school_passed--未处理,enterprise_passed--通过，enterprise_refused--不合适
      searchParams: {
        school_id: null,
        school_name: null
      },
      studentApplyList: [],
      total: null,
      row: {},
      ...num, // 投递统计
      ...update,
    };
  },
  mounted() {
    this.getNum();
    this.getStudentApplyList("school_passed");
    document.addEventListener('click', () => {
      this.operate = false
    })
  },
  watch: {
    'searchParams.school_name'() {
      this.getStudentApplyList()
    }
  },
  methods: {
    tab(index) {
      this.active = index;
      this.$refs.pagination.page = 1
      this.$refs.pagination.page_size = 10
      this.getStudentApplyList();
    },
    async getNum() {
      let res = await this.$api.studentManage.getStudentApplyList({
        apply_status: "school_passed"
      });
      if (res.code === 0) {
        this.untreatedNum = res.data.count;
      }
      let res1 = await this.$api.studentManage.getStudentApplyList({
        apply_status: "enterprise_passed"
      });
      if (res1.code === 0) {
        this.passedNum = res1.data.count;
      }
      let res2 = await this.$api.studentManage.getStudentApplyList({
        apply_status: "enterprise_refused"
      });
      if (res2.code === 0) {
        this.refusedNum = res2.data.count;
      }
    },
    async getStudentApplyList() {
      let params = {
        page: this.$refs.pagination.page,
        page_size: this.$refs.pagination.page_size,
        apply_status: this.active
      };
      Object.assign(params, this.searchParams);
      let params1 = this.delNullVal(params);
      let res = await this.$api.studentManage.getStudentApplyList(params1);
      if (res.code === 0) {
        this.studentApplyList = res.data.items;
        this.total = res.data.count;
      }
    },
    edit(operateId, jobId) {
      this.operate = !this.operate;
      this.operateId = operateId;
      this.jobId = jobId;
    },
    async update(apply_status) {
      let params = {
        apply_status
      }
      let res = await this.$api.job.updateDeliver(this.operateId, params)
      console.log(res)
      if (res.code === 0) {
        this.$message.success('编辑成功！')
        this.getStudentApplyList()
        this.getNum()
        this.operate = false
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  padding: 20px;
  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
    .status {
      display: flex;
      div {
        line-height: 50px;
        color: #828282;
        font-size: 14px;
        margin-right: 70px;
        &.active {
          color: #000;
          font-weight: bold;
          &::after {
            content: "";
            display: block;
            width: 34px;
            height: 4px;
            background: #1490ed;
            margin: 0 auto;
          }
        }
      }
    }
    .el-input {
      width: 250px;
    }
  }
  .resume {
    margin-top: 24px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 1px 16px 0px #d2d2d2;
      border-radius: 24px;
      padding: 24px 16px;
      color: #929292;
      margin-bottom: 20px;
      .left-content {
        display: flex;
        align-items: center;
        img {
          width: 57px;
          height: 57px;
        }
        .base-info {
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          color: #929292;
          .line-1 {
            strong {
              color: #000;
              margin-right: 20px;
            }
          }
          .line-2 {
            span:not(:last-child) {
              &::after {
                content: "";
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #929292;
                margin: 0 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .right-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 57px;
        position: relative;
        .edit-btn {
          display: inline-block;
          width: 73px;
          height: 31px;
          text-align: center;
          line-height: 31px;
          background: rgba(59, 163, 240, 1);
          border-radius: 9px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
        .operate {
          position: absolute;
          right: 0;
          top: 100%;
          z-index: 1;
          width: 80px;
          padding: 0 9px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #dcefff;
          background: #fff;
          div {
            cursor: pointer;
          }
          div:not(:last-child) {
            border-bottom: 1px solid #dcefff;
          }
        }
      }
    }
  }
}
</style>
